import { Component, OnInit, Input, Inject, Optional, Injector } from '@angular/core';
import { CART_ANALYTIC_TRACKERS, cartHelper, CartState, getCart, getCartLines, getCartTotalPrice, ICart } from '../../../cart';
import { CartEventsService } from '../../../cart/services/cart-events.service';
import { filter, take } from 'rxjs/operators';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CartAnalyticTracker } from '../../../cart/models/cart/i-cart-analytic-tracker';

@Component({
  standalone: false,
  selector: 'cart-btn-quantity-price',
  templateUrl: './cart-btn-quantity-price.component.html',
  styleUrls: ['./cart-btn-quantity-price.component.scss']
})
export class CartBtnQuantityPriceComponent extends CustomComponent implements OnInit {
  @Input() size: 'lg' = null;

  public quantity: number;
  public totalPrice: number;
  public currency: string;
  public cart$: Observable<ICart>;
  public sizeCssClass = '';

  private trackers: CartAnalyticTracker[];

  constructor(private _cartStore: Store<CartState>,
              private _cartEvents: CartEventsService,
              private injector: Injector) {
    super();

    this.cart$ = _cartStore.pipe(
      select(getCart),
      filter((cart) => Boolean(cart) && Boolean(cart.bakery))
    );

    this.trackers = this.injector.get(CART_ANALYTIC_TRACKERS, []);
  }

  ngOnInit() {
    this.sizeCssClass = this.size ? 'cart-btn-' + this.size : '';

    this.addSubscriber(this.cart$.subscribe((cart) => {
      const { bakery } = cart;
      this.currency = bakery && bakery.country && bakery.country.currencySymbol || '';
    }));

    this.addSubscriber(this._cartStore.select(getCartLines)
      .subscribe((lines) => this.quantity = cartHelper.getQuantityFromOrderLines(lines)));

    this.addSubscriber(this._cartStore.select(getCartTotalPrice)
      .subscribe((totalPrice) => this.totalPrice = totalPrice));
  }

  public onClick() {
    if (this._cartEvents.isCartClose()) {
      this.trackViewCart();
    }

    this._cartEvents.toggleCart();
  }

  private trackViewCart() {
    new Promise<void>((resolve) => {
      this.cart$.pipe(take(1)).subscribe((cart) => {
        try {
          this.trackers.forEach((tracker) => {
            tracker.trackViewCart(cart);
          });
        } catch (e) {
          console.error('CartBtnQuantityPriceComponent trackViewCart error: ', e);
        }

        resolve();
      });
    });
  }
}
